import React from 'react';
import { Link } from 'react-router-dom';

export default function CateCard(props) {
  let linkTo = '';
  if (props.cateEn) {
    if (props.cateEn == 'Brands') {
      linkTo = `/machineUI/brands/${props.machineID}/${props.id}/${props.id}`;
    } else if (props.cateEn == 'Categories') {
      linkTo = `/machineUI/category/${props.machineID}/${props.id}/${props.id}`;
    } else {
      linkTo = `/machineUI/category/${props.brandOrCate}/${props.id}/${props.id}`;
    }
  }

  return (
    <div
      className="col-md-9 mb-4 category-card"
      style={{
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
      }}
    >
      <Link to={props.noChange ? `/machineUI/homePage/${props.machineID}` : linkTo}>
        {props.column === '2' ? (
          <div
            className="card"
            style={{
              border: 'none',
              borderRadius: '1em',
              borderBottom: 'none',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              height: '195px',
              paddingTop: '1rem',
              justifyContent: 'center',
            }}
          >
            <img height={195} src={props.image} alt={props.imagename} className="p-3" />
          </div>
        ) : (
          <div
            className="card"
            style={{
              border: 'none',
              borderRadius: '1em',
              borderBottom: 'none',
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              height: '350px',
              paddingTop: '1rem',
              justifyContent: 'center',
            }}
          >
            <img height={350} src={props.image} alt={props.imagename} className="p-3" />
          </div>
        )}
      </Link>
      <div className="card-body">
        <h5 className="card-category-title d-flex justify-content-center">{props.catename}</h5>
      </div>
    </div>
  );
}
